<template>
  <div class="care-plan-block-wrapper">
    <div class="care-plan-block-container">
      <div class="text-content-container">
        <div class="text-title-sm text-title-subscription">
          {{ $t('care.sectionSubscription.title') }}
        </div>
        <div class="note-list">
          <div class="note-item text-content-desc-xxsm">
            {{ $t('care.sectionSubscription.note1') }}
          </div>
          <div class="note-item text-content-desc-xxsm">
            {{ $t('care.sectionSubscription.note2') }}
          </div>
        </div>
      </div>
      <div class="care-plan-card-tab-outer-wrapper">
        <care-plan-card-tab></care-plan-card-tab>
      </div>
    </div>
  </div>
</template>
<script>
import CarePlanCardTab from './CarePlanCardTab.vue';

export default {
  name: 'care-plan-block',
  components: {
    CarePlanCardTab,
  },
};
</script>
<style lang="sass" scoped>
.care-plan-block-wrapper
  width: 100vw
  padding-top: 56px
  background-color: $background-primary
  overflow: hidden
  .care-plan-block-container
    display: flex
    flex-direction: column
    align-items: center
    .text-content-container
      width: 85vw
      margin-bottom: 40px
      .text-title-subscription
        margin: 4px 0
      .note-list
        .note-item
          line-height: 1.5

@media screen and (max-width: 768px)
  .care-plan-block-wrapper
    padding-top: 32px
    .care-plan-block-container
      .text-content-container
        margin-bottom: 24px

@media screen and (max-width: 414px)
  .care-plan-block-wrapper
    .care-plan-block-container
      .text-content-container
        margin-bottom: 8px

@media screen and (max-width: 320px)
  .care-plan-block-wrapper
    .care-plan-block-container
      .text-content-container
        width: 70vw
</style>
